module.exports = __webpack_public_path__ + "static/4-a7d65c11ae474c2cae55cb30174f2bb8.jpg";